// extracted by mini-css-extract-plugin
export var active = "DesktopMenuVersion1-module--active--d2825";
export var advImg = "DesktopMenuVersion1-module--advImg--9360f";
export var advImgWrapper = "DesktopMenuVersion1-module--advImgWrapper--12a15";
export var arrowButton = "DesktopMenuVersion1-module--arrowButton--94dec";
export var btn = "DesktopMenuVersion1-module--btn--e44eb";
export var cMarginTop = "DesktopMenuVersion1-module--c-margin-top--5b105";
export var cPadding = "DesktopMenuVersion1-module--c-padding--5b4b2";
export var cPaddingBottom = "DesktopMenuVersion1-module--c-padding-bottom--2a049";
export var cPaddingTop = "DesktopMenuVersion1-module--c-padding-top--48e6f";
export var categoryTitle = "DesktopMenuVersion1-module--categoryTitle--d71e0";
export var childSvgIcon = "DesktopMenuVersion1-module--childSvgIcon--f4a73";
export var defaultDropdown = "DesktopMenuVersion1-module--defaultDropdown--59596";
export var growDown = "DesktopMenuVersion1-module--growDown--09b0a";
export var level1 = "DesktopMenuVersion1-module--level1--ecf24";
export var level2 = "DesktopMenuVersion1-module--level2--a4e71";
export var level3 = "DesktopMenuVersion1-module--level3--e0171";
export var level3Box = "DesktopMenuVersion1-module--level3Box--4e47f";
export var level3Content = "DesktopMenuVersion1-module--level3Content--f7e31";
export var level3Tags = "DesktopMenuVersion1-module--level3Tags--f0b48";
export var maxWidth = "DesktopMenuVersion1-module--max-width--63f48";
export var megaMenu = "DesktopMenuVersion1-module--megaMenu--39497";
export var megaMenuHeader = "DesktopMenuVersion1-module--megaMenuHeader--a782a";
export var megaMenus = "DesktopMenuVersion1-module--megaMenus--340f2";
export var menuContainer = "DesktopMenuVersion1-module--menuContainer--c85fc";
export var menuItem = "DesktopMenuVersion1-module--menuItem--903ef";
export var menuTitle = "DesktopMenuVersion1-module--menuTitle--e6c33";
export var navigation = "DesktopMenuVersion1-module--navigation--3a95c";
export var onPrimaryOutline = "DesktopMenuVersion1-module--onPrimaryOutline--c0e28";
export var parent = "DesktopMenuVersion1-module--parent--6b9a9";
export var parentWrapper = "DesktopMenuVersion1-module--parentWrapper--629bc";
export var primaryFilled = "DesktopMenuVersion1-module--primaryFilled--e34f6";
export var primaryFilledNew = "DesktopMenuVersion1-module--primaryFilledNew--e8b8d";
export var primaryFilledTwo = "DesktopMenuVersion1-module--primaryFilledTwo--a28a6";
export var primaryNoStrokeWithIcon = "DesktopMenuVersion1-module--primaryNoStrokeWithIcon--28393";
export var primaryOutline = "DesktopMenuVersion1-module--primaryOutline--10a4b";
export var primaryOutlineWithIcon = "DesktopMenuVersion1-module--primaryOutlineWithIcon--2526d";
export var quote = "DesktopMenuVersion1-module--quote--d9f28";
export var quote2 = "DesktopMenuVersion1-module--quote2--cdcce";
export var searchIcon = "DesktopMenuVersion1-module--searchIcon--05f44";
export var searchInput = "DesktopMenuVersion1-module--searchInput--74b3c";
export var searchResults = "DesktopMenuVersion1-module--searchResults--57660";
export var searchWrapper = "DesktopMenuVersion1-module--searchWrapper--814ca";
export var subTitle = "DesktopMenuVersion1-module--subTitle--fa0c4";
export var svgWrapper = "DesktopMenuVersion1-module--svgWrapper--6cb0f";
export var tagButton = "DesktopMenuVersion1-module--tagButton--c0316";
export var title = "DesktopMenuVersion1-module--title--ceca3";